import { find } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { findByProp } from '../../../shared/util/collection';
import Workflow from '../../../shared/model/workflow/Workflow';
import LabelComponent from '../global/Label';

const Stage = ({ workflows, idWorkflow, idStage }) => {
  const workflow = useMemo(() => findByProp(workflows, idWorkflow), [workflows, idWorkflow]);
  if (!workflow) {
    return null;
  }

  const stage = find(workflow?.stages || [], (s) => s?.id === idStage);
  if (!stage) {
    return null;
  }
  return (
    <>
      <LabelComponent
        name={stage.isMilestone ? 'M' : 'S'}
        toolTip={stage.isMilestone ? 'Milestone' : 'Step'}
        type={stage.isMilestone ? 'error' : 'default'}
      />
      {stage.getName()}
    </>
  );
};

Stage.propTypes = {
  workflows: PropTypes.arrayOf(PropTypes.instanceOf(Workflow)).isRequired,
  idWorkflow: PropTypes.string.isRequired,
  idStage: PropTypes.string.isRequired
};

export default Stage;
